import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { FileCheck2, CalendarClock } from "lucide-react";
import { FILING_STATUS, FilingStatusBadge, deadlineTone } from "@/components/fleet/filingStatus";

export function FilingsWidget({ isAdmin }) {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/fleet/filings/overview").then(({ data }) => setO(data)).catch(() => {}); }, []);
  if (!o) return null;
  const mine = o.open.filter((f) => (isAdmin ? ["requested", "changes_requested", "approved"] : ["awaiting_approval"]).includes(f.status));
  const others = o.open.filter((f) => !mine.includes(f)).slice(0, 5);
  const urgent = mine.length > 0;
  return (
    <Card className={`p-6 mb-6 border-t-4 ${urgent ? "border-t-amber-500 bg-gradient-to-b from-amber-50/80 to-white" : "border-t-emerald-500 bg-gradient-to-b from-emerald-50/60 to-white"}`} data-testid="filings-widget">
      <div className="flex items-start justify-between gap-4 mb-4 flex-wrap">
        <div>
          <div className={`tag-mono ${urgent ? "text-amber-700" : "text-blue-700"}`}>FLEET FILINGS · IRP · 2290 · IFTA</div>
          <h2 className="text-xl font-bold font-heading text-slate-900">{urgent ? (isAdmin ? `${mine.length} filing${mine.length > 1 ? "s" : ""} need your action` : `${mine.length} filing${mine.length > 1 ? "s" : ""} awaiting your approval`) : "Filings on track"}</h2>
        </div>
        <Link to="/fleet?tab=filings" className="text-sm text-blue-700 hover:underline" data-testid="filings-widget-link">Open Fleet →</Link>
      </div>
      <div className="grid lg:grid-cols-[1fr_320px] gap-6">
        <div className="divide-y divide-slate-100">
          {mine.length === 0 && others.length === 0 && <div className="text-sm text-slate-500 py-6 text-center">No open filings.</div>}
          {[...mine, ...others].map((f) => (
            <Link key={f.id} to="/fleet?tab=filings" className="py-2.5 flex items-center justify-between gap-3 hover:bg-slate-50 -mx-2 px-2 rounded" data-testid={`filings-widget-row-${f.id}`}>
              <div className="flex items-center gap-3"><span className={`w-1.5 h-8 rounded ${FILING_STATUS[f.status].bar}`} /><div><div className="font-medium text-slate-900">{f.type_label} · {f.period}</div><div className="text-xs text-slate-500">{isAdmin && <span className="text-blue-700">{f.company} · </span>}{(f.vehicle_ids || []).length} vehicle(s){f.due_date ? ` · due ${f.due_date}` : ""}</div></div></div>
              <FilingStatusBadge status={f.status} isAdmin={isAdmin} />
            </Link>
          ))}
        </div>
        <div>
          <div className="tag-mono text-slate-500 mb-2 flex items-center gap-1"><CalendarClock className="h-3 w-3" />Upcoming deadlines</div>
          <div className="space-y-2">
            {o.deadlines.length === 0 && <div className="text-sm text-slate-500">Nothing due within 75 days.</div>}
            {o.deadlines.map((d) => (
              <div key={d.label} className={`rounded-md border px-3 py-2 text-sm flex items-center justify-between ${deadlineTone(d.days_left)}`} data-testid={`deadline-${d.filing_type}-${d.period}`}>
                <span className="font-medium flex items-center gap-2"><FileCheck2 className="h-4 w-4" />{d.label}</span><span className="font-mono text-xs">{d.due_date} · {d.days_left}d</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}
